var _TrueTypeTableInfo = /** @class */ (function () {
    function _TrueTypeTableInfo() {
    }
    Object.defineProperty(_TrueTypeTableInfo.prototype, "_empty", {
        get: function () {
            var empty = (this._offset === this._length && this._length === this._checksum && this._checksum === 0);
            return empty;
        },
        enumerable: true,
        configurable: true
    });
    return _TrueTypeTableInfo;
}());
export { _TrueTypeTableInfo };
var _TrueTypeOS2Table = /** @class */ (function () {
    function _TrueTypeOS2Table() {
    }
    return _TrueTypeOS2Table;
}());
export { _TrueTypeOS2Table };
var _TrueTypePostTable = /** @class */ (function () {
    function _TrueTypePostTable() {
    }
    return _TrueTypePostTable;
}());
export { _TrueTypePostTable };
var _TrueTypeNameTable = /** @class */ (function () {
    function _TrueTypeNameTable() {
    }
    return _TrueTypeNameTable;
}());
export { _TrueTypeNameTable };
var _TrueTypeMicrosoftCmapSubTable = /** @class */ (function () {
    function _TrueTypeMicrosoftCmapSubTable() {
    }
    return _TrueTypeMicrosoftCmapSubTable;
}());
export { _TrueTypeMicrosoftCmapSubTable };
var _TrueTypeHorizontalHeaderTable = /** @class */ (function () {
    function _TrueTypeHorizontalHeaderTable() {
    }
    return _TrueTypeHorizontalHeaderTable;
}());
export { _TrueTypeHorizontalHeaderTable };
var _TrueTypeHeadTable = /** @class */ (function () {
    function _TrueTypeHeadTable() {
    }
    return _TrueTypeHeadTable;
}());
export { _TrueTypeHeadTable };
var _TrueTypeCmapTable = /** @class */ (function () {
    function _TrueTypeCmapTable() {
    }
    return _TrueTypeCmapTable;
}());
export { _TrueTypeCmapTable };
var _TrueTypeCmapSubTable = /** @class */ (function () {
    function _TrueTypeCmapSubTable() {
    }
    return _TrueTypeCmapSubTable;
}());
export { _TrueTypeCmapSubTable };
var _TrueTypeAppleCmapSubTable = /** @class */ (function () {
    function _TrueTypeAppleCmapSubTable() {
    }
    return _TrueTypeAppleCmapSubTable;
}());
export { _TrueTypeAppleCmapSubTable };
var _TrueTypeTrimmedCmapSubTable = /** @class */ (function () {
    function _TrueTypeTrimmedCmapSubTable() {
    }
    return _TrueTypeTrimmedCmapSubTable;
}());
export { _TrueTypeTrimmedCmapSubTable };
